import { Injectable } from '@angular/core';

import { RidangoReduxAction, Ticket } from '@ridango/core';
import { CompanyHistoryTicket } from '../purchase-history.model';

import { Action } from 'redux';

export interface PurchaseHistoryAction extends Action {
    type: string;
    payload?: any;
}

@Injectable()
export class PurchaseHistoryActions {
    static FETCH_PURCHASE_HISTORY = '[PurchaseHistory]: Fetch start';
    static SET_HISTORY_TICKETS = '[PurchaseHistory]: Set purchase history tickets';
    static SET_HISTORY_CARTS = '[PurchaseHistory]: Set purchase history carts';
    static IS_LOADING = '[PurchaseHistory]: Set loading';
    static GET_HISTORY_FAILED = '[PurchaseHistory]: Get purchase history failed';
    static SET_START_DATE = '[PurhcaseHistory]: Set start date';
    static SET_END_DATE = '[PurhcaseHistory]: Set end date';

    fetchPurchaseHistory(): PurchaseHistoryAction {
        return {
            type: PurchaseHistoryActions.FETCH_PURCHASE_HISTORY
        };
    }

    setTickets(payload: Ticket[] | CompanyHistoryTicket[]): RidangoReduxAction {
        return {
            type: PurchaseHistoryActions.SET_HISTORY_TICKETS,
            payload: payload
        };
    }

    setCarts(payload: any[]): RidangoReduxAction {
        return {
            type: PurchaseHistoryActions.SET_HISTORY_TICKETS,
            payload: payload
        };
    }

    setIsLoading(payload: boolean): RidangoReduxAction {
        return {
            type: PurchaseHistoryActions.IS_LOADING,
            payload: payload
        };
    }

    getPurchaseHistoryFailed(error) {
        return {
            type: PurchaseHistoryActions.GET_HISTORY_FAILED,
            payload: error
        };
    }

    setStartDate(payload: Date): RidangoReduxAction {
        return {
            type: PurchaseHistoryActions.SET_START_DATE,
            payload: payload
        };
    }

    setEndDate(payload: Date): RidangoReduxAction {
        return {
            type: PurchaseHistoryActions.SET_END_DATE,
            payload: payload
        };
    }
}
